import { z } from 'zod';

const MIN_DATE = new Date('1900-01-01');

/**
 * Parse date strings keeping string type and YYYY-MM-DD format
 */
export const ZodDateString = z.union([
  z
    .string()
    .regex(/^\d{4}-\d{2}-\d{2}/)
    .pipe(z.coerce.date())
    .pipe(z.date().min(MIN_DATE))
    .transform((date) => date.toISOString().split('T')[0])
    .meta({ override: { type: 'string' } }),
  z
    .date()
    .min(MIN_DATE)
    .transform((date) => date.toISOString().split('T')[0])
    .meta({ override: { type: 'string' } }),
]);

/**
 * Parse datetime strings keeping string type and ISO format
 */
export const ZodDateTimeString = z.union([
  z
    .string()
    .pipe(z.coerce.date())
    .transform((date) => date.toISOString())
    .meta({ override: { type: 'string' } }),
  z
    .date()
    .transform((date) => date.toISOString())
    .meta({ override: { type: 'string' } }),
]);

/**
 * Parse iso dates
 */
export const ZodIsoDateString = z.union([
  z
    .string()
    .refine(
      (value) => {
        const date = new Date(value);
        return !isNaN(date.getTime()) && value === date.toISOString();
      },
      { message: 'Invalid ISO 8601 date string' },
    )
    .pipe(z.coerce.date())
    .transform((date) => date.toISOString())
    .meta({ override: { type: 'string' } }),
  z
    .date()
    .transform((date) => date.toISOString())
    .meta({ override: { type: 'string' } }),
]);
